if (!customElements.get('card-stack-carousel')) {
  customElements.define(
    'card-stack-carousel',
    class CardStackCarousel extends HTMLElement {
      constructor() {
        super();
        this.track = this.querySelector('[data-card-stack-track]');
        this.slides = Array.from(this.querySelectorAll('[data-card-stack-slide]'));
        this.onScroll = this.onScroll.bind(this);
      }

      connectedCallback() {
        if (!this.track || this.slides.length === 0) return;
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.update();
      }

      disconnectedCallback() {
        if (!this.track) return;
        this.track.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }

      onScroll() {
        if (this.rafId) cancelAnimationFrame(this.rafId);
        this.rafId = requestAnimationFrame(() => this.update());
      }

      update() {
        const trackRect = this.track.getBoundingClientRect();
        const center = trackRect.left + trackRect.width / 2;

        this.slides.forEach((slide) => {
          const rect = slide.getBoundingClientRect();
          const slideCenter = rect.left + rect.width / 2;
          const distance = Math.min(Math.abs(center - slideCenter) / (trackRect.width / 2), 1.6);
          slide.style.setProperty('--distance', distance.toFixed(3));
        });
      }
    }
  );
}
